import { useEffect } from 'react';
import { usePreferences } from '../stores/preferences';

/**
 * Mantiene el documento en sintonía con las preferencias guardadas.
 *
 * `index.html` ya las aplica antes del primer pintado para que no haya
 * parpadeo; este efecto se ocupa de los cambios posteriores. Vive en la raíz
 * de la aplicación y no en el panel de accesibilidad, porque la preferencia
 * debe seguir aplicada aunque ese panel no esté montado.
 */
export function useAppliedPreferences(): void {
  const fontScale = usePreferences((state) => state.fontScale);
  const theme = usePreferences((state) => state.theme);
  const reduceMotion = usePreferences((state) => state.reduceMotion);

  useEffect(() => {
    document.documentElement.style.setProperty('--a11y-font-scale', String(fontScale));
  }, [fontScale]);

  useEffect(() => {
    document.documentElement.dataset.bsTheme = theme;
  }, [theme]);

  useEffect(() => {
    document.documentElement.classList.toggle('a11y-reduce-motion', reduceMotion);
  }, [reduceMotion]);
}
